module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1503-4d9b268c7961596c1d4e3344343f7a25.png";